/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiLabParams,
  LabCreateUpdateDTO,
  LabMoveRequest,
  LabViewDTO,
  LabViewDTOPaginationResult,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiLab = (
    params?: GetApiLabParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LabViewDTOPaginationResult>(
      {url: `/api/Lab`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiLabInfiniteQueryKey = (params?: GetApiLabParams,) => {
    return [
    'infinite', `/api/Lab`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiLabQueryKey = (params?: GetApiLabParams,) => {
    return [
    `/api/Lab`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiLabInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiLab>>>, TError = ProblemDetails>(params?: GetApiLabParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiLabInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLab>>> = ({ signal }) => getApiLab(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiLabInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLab>>>
export type GetApiLabInfiniteQueryError = ProblemDetails


export function useGetApiLabInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLab>>>, TError = ProblemDetails>(
 params: undefined |  GetApiLabParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLab>>,
          TError,
          Awaited<ReturnType<typeof getApiLab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLabInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLab>>>, TError = ProblemDetails>(
 params?: GetApiLabParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLab>>,
          TError,
          Awaited<ReturnType<typeof getApiLab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLabInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLab>>>, TError = ProblemDetails>(
 params?: GetApiLabParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiLabInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLab>>>, TError = ProblemDetails>(
 params?: GetApiLabParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiLabInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiLabQueryOptions = <TData = Awaited<ReturnType<typeof getApiLab>>, TError = ProblemDetails>(params?: GetApiLabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiLabQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLab>>> = ({ signal }) => getApiLab(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiLabQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLab>>>
export type GetApiLabQueryError = ProblemDetails


export function useGetApiLab<TData = Awaited<ReturnType<typeof getApiLab>>, TError = ProblemDetails>(
 params: undefined |  GetApiLabParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLab>>,
          TError,
          Awaited<ReturnType<typeof getApiLab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLab<TData = Awaited<ReturnType<typeof getApiLab>>, TError = ProblemDetails>(
 params?: GetApiLabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLab>>,
          TError,
          Awaited<ReturnType<typeof getApiLab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLab<TData = Awaited<ReturnType<typeof getApiLab>>, TError = ProblemDetails>(
 params?: GetApiLabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiLab<TData = Awaited<ReturnType<typeof getApiLab>>, TError = ProblemDetails>(
 params?: GetApiLabParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLab>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiLabQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiLab = (
    labCreateUpdateDTO?: LabCreateUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LabViewDTO>(
      {url: `/api/Lab`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: labCreateUpdateDTO, signal
    },
      options);
    }




export const getPostApiLabMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLab>>, TError,{data?: LabCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiLab>>, TError,{data?: LabCreateUpdateDTO}, TContext> => {

const mutationKey = ['postApiLab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLab>>, {data?: LabCreateUpdateDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiLab(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLabMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLab>>>
    export type PostApiLabMutationBody = LabCreateUpdateDTO | undefined
    export type PostApiLabMutationError = ProblemDetails

    export const usePostApiLab = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLab>>, TError,{data?: LabCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLab>>,
        TError,
        {data?: LabCreateUpdateDTO},
        TContext
      > => {
      return useMutation(getPostApiLabMutationOptions(options), queryClient);
    }
    export const getApiLabInstitutionIdLabId = (
    institutionId: string,
    labId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LabViewDTO>(
      {url: `/api/Lab/${institutionId}/${labId}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiLabInstitutionIdLabIdInfiniteQueryKey = (institutionId: string,
    labId: string,) => {
    return [
    'infinite', `/api/Lab/${institutionId}/${labId}`
    ] as const;
    }

export const getGetApiLabInstitutionIdLabIdQueryKey = (institutionId: string,
    labId: string,) => {
    return [
    `/api/Lab/${institutionId}/${labId}`
    ] as const;
    }


export const getGetApiLabInstitutionIdLabIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>>, TError = ProblemDetails>(institutionId: string,
    labId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiLabInstitutionIdLabIdInfiniteQueryKey(institutionId,labId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>> = ({ signal }) => getApiLabInstitutionIdLabId(institutionId,labId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: institutionId !== null && institutionId !== undefined && labId !== null && labId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiLabInstitutionIdLabIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>>
export type GetApiLabInstitutionIdLabIdInfiniteQueryError = ProblemDetails


export function useGetApiLabInstitutionIdLabIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>,
          TError,
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLabInstitutionIdLabIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>,
          TError,
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLabInstitutionIdLabIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiLabInstitutionIdLabIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiLabInstitutionIdLabIdInfiniteQueryOptions(institutionId,labId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiLabInstitutionIdLabIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError = ProblemDetails>(institutionId: string,
    labId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiLabInstitutionIdLabIdQueryKey(institutionId,labId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>> = ({ signal }) => getApiLabInstitutionIdLabId(institutionId,labId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: institutionId !== null && institutionId !== undefined && labId !== null && labId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiLabInstitutionIdLabIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>>
export type GetApiLabInstitutionIdLabIdQueryError = ProblemDetails


export function useGetApiLabInstitutionIdLabId<TData = Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>,
          TError,
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLabInstitutionIdLabId<TData = Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>,
          TError,
          Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLabInstitutionIdLabId<TData = Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiLabInstitutionIdLabId<TData = Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError = ProblemDetails>(
 institutionId: string,
    labId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLabInstitutionIdLabId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiLabInstitutionIdLabIdQueryOptions(institutionId,labId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiLabInstitutionIdLabId = (
    institutionId: string,
    labId: string,
    labCreateUpdateDTO?: LabCreateUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LabViewDTO>(
      {url: `/api/Lab/${institutionId}/${labId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: labCreateUpdateDTO, signal
    },
      options);
    }




export const getPutApiLabInstitutionIdLabIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiLabInstitutionIdLabId>>, TError,{institutionId: string;labId: string;data?: LabCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiLabInstitutionIdLabId>>, TError,{institutionId: string;labId: string;data?: LabCreateUpdateDTO}, TContext> => {

const mutationKey = ['putApiLabInstitutionIdLabId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiLabInstitutionIdLabId>>, {institutionId: string;labId: string;data?: LabCreateUpdateDTO}> = (props) => {
          const {institutionId,labId,data} = props ?? {};

          return  putApiLabInstitutionIdLabId(institutionId,labId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiLabInstitutionIdLabIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiLabInstitutionIdLabId>>>
    export type PutApiLabInstitutionIdLabIdMutationBody = LabCreateUpdateDTO | undefined
    export type PutApiLabInstitutionIdLabIdMutationError = ProblemDetails

    export const usePutApiLabInstitutionIdLabId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiLabInstitutionIdLabId>>, TError,{institutionId: string;labId: string;data?: LabCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiLabInstitutionIdLabId>>,
        TError,
        {institutionId: string;labId: string;data?: LabCreateUpdateDTO},
        TContext
      > => {
      return useMutation(getPutApiLabInstitutionIdLabIdMutationOptions(options), queryClient);
    }
    export const deleteApiLabInstitutionIdLabId = (
    institutionId: string,
    labId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/Lab/${institutionId}/${labId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiLabInstitutionIdLabIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiLabInstitutionIdLabId>>, TError,{institutionId: string;labId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiLabInstitutionIdLabId>>, TError,{institutionId: string;labId: string}, TContext> => {

const mutationKey = ['deleteApiLabInstitutionIdLabId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiLabInstitutionIdLabId>>, {institutionId: string;labId: string}> = (props) => {
          const {institutionId,labId} = props ?? {};

          return  deleteApiLabInstitutionIdLabId(institutionId,labId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiLabInstitutionIdLabIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiLabInstitutionIdLabId>>>

    export type DeleteApiLabInstitutionIdLabIdMutationError = ProblemDetails

    export const useDeleteApiLabInstitutionIdLabId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiLabInstitutionIdLabId>>, TError,{institutionId: string;labId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiLabInstitutionIdLabId>>,
        TError,
        {institutionId: string;labId: string},
        TContext
      > => {
      return useMutation(getDeleteApiLabInstitutionIdLabIdMutationOptions(options), queryClient);
    }
    export const postApiLabInstitutionIdLabIdMove = (
    institutionId: string,
    labId: string,
    labMoveRequest?: LabMoveRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LabViewDTO>(
      {url: `/api/Lab/${institutionId}/${labId}/move`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: labMoveRequest, signal
    },
      options);
    }




export const getPostApiLabInstitutionIdLabIdMoveMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLabInstitutionIdLabIdMove>>, TError,{institutionId: string;labId: string;data?: LabMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiLabInstitutionIdLabIdMove>>, TError,{institutionId: string;labId: string;data?: LabMoveRequest}, TContext> => {

const mutationKey = ['postApiLabInstitutionIdLabIdMove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLabInstitutionIdLabIdMove>>, {institutionId: string;labId: string;data?: LabMoveRequest}> = (props) => {
          const {institutionId,labId,data} = props ?? {};

          return  postApiLabInstitutionIdLabIdMove(institutionId,labId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLabInstitutionIdLabIdMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLabInstitutionIdLabIdMove>>>
    export type PostApiLabInstitutionIdLabIdMoveMutationBody = LabMoveRequest | undefined
    export type PostApiLabInstitutionIdLabIdMoveMutationError = ProblemDetails

    export const usePostApiLabInstitutionIdLabIdMove = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLabInstitutionIdLabIdMove>>, TError,{institutionId: string;labId: string;data?: LabMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLabInstitutionIdLabIdMove>>,
        TError,
        {institutionId: string;labId: string;data?: LabMoveRequest},
        TContext
      > => {
      return useMutation(getPostApiLabInstitutionIdLabIdMoveMutationOptions(options), queryClient);
    }
